import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Checkboxes, FileInput } from "../../../FlowConfigurationInputs";
import FormControl from "@material-ui/core/FormControl";
import { MenuItem, Select } from "@material-ui/core";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 2,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #E6E6E6',
        //borderLeft:"6px solid #df7070",
        paddingLeft: 5,
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
    },
}))(InputBase);


/**
 * @Description this page OCR Library's Image to Text Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
function ImageToText({
    action,
    variables,
    variableRender,
    setOpenVariable
}) {

    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.OCR.";
    const [localType, setLocalType] = useState("");
    const options = {
        fileInput: {
            checkExtension: (ext) => {
                return true;
            },
            fileType: "",
        },
        checkboxes: { label: label + "TRIM-TEXT" },
    };

    // set localtype initial value
    useEffect(() => {
        if (!action.fields.localType) {
            action.fields.localType = { value: '' }
        }
        else {
            setLocalType(action.fields.localType.value)
        }
    }, [variables, action])

    // set selected local type
    function handleLocalType(event) {
        setLocalType(event.target.value);
        action.fields.localType.value = event.target.value;
    }

    return (
        <div>
            <div className="form-element">
                {t(label + "IMAGE-PATH")}
                <FileInput
                    action={action}
                    options={options.fileInput}
                    inputName="imagePath"
                    isRequired
                    isSize={true}
                />
            </div>
            <div className="form-element">
                <Checkboxes
                    action={action}
                    options={options.checkboxes}
                    inputName="isTrim"
                    isRequired
                />
            </div>
            <div className="form-element">
                {t(label + "SELECT-LOCALE")}
                <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
                    <Select value={localType} onChange={handleLocalType} input={(localType) ? null : <BootstrapInput />}>
                        <MenuItem value="BASEDONLOCALE">{t(label + "BASED-ON-LOCALE")}</MenuItem>
                        <MenuItem value="ENGLISH">{t(label + "ENGLISH")}</MenuItem>

                    </Select>
                </FormControl>
            </div>
            <div className="form-element">
                {t(label + "ASSIGN-VALUE")}
                <VariablePicker
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    filter="string"
                    isRequired={true}
                />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
        </div>
    );
}

export default ImageToText;